import React from 'react';
import {
  DataGridButton,
  IColumnType,
  IDataType,
  SisDataGridColumns,
} from '../../../components/table';
import { TimeSpanCell, TimeSpanCellSortValue, TimeSpanDecimalCell, TypeNameCell } from '../../Tasks/Columns';
import ChartCell from '../../WorkSheets/Columns';
import { CustomerProjectBillingStatusTranslation } from '../../../types/customerProject.types';

export const Columns = (handleEdit, translate): SisDataGridColumns => [
  {
    dataField: 'taskRequestorName',
    width: '120px',
    caption: 'Requestor name',
  },
  {
    dataType: IDataType.string,
    dataField: 'taskName',
    width: '400px',
    caption: 'Task name',
    cssClass: 'dg-align-left',
  },
  {
    dataField: 'workActivityName',
    width: '200px',
    caption: 'Activity',
    lookupPickBy: 'workActivityName',
  },
  {
    dataField: 'operatorName',
    width: '120px',
    caption: 'Operator',
    lookupPickBy: 'operatorName',
  },
  {
    dataField: 'taskAssetTopLevelParenName',
    width: '150px',
    caption: 'Top level asset name',
    lookupPickBy: 'taskAssetTopLevelParenName',
  },
  {
    dataField: 'taskAssetName',
    width: '150px',
    caption: 'Asset name',
    lookupPickBy: 'taskAssetName',
  },
  {
    dataField: 'taskBillingStatus',
    width: '100px',
    caption: 'Billing status',
    cellRender: (cellData: any) => {
      if (cellData.data.taskBillingStatus)
        return (
          <>
            {translate!(
              CustomerProjectBillingStatusTranslation[cellData.data.taskBillingStatus],
              `CustomersProjects.Status`,
            )}
          </>
        );

      return <></>;
    },
    calculateCellValue: (data: any) => {
      if (data.taskBillingStatus)
        return translate!(
          CustomerProjectBillingStatusTranslation[data.taskBillingStatus],
          `CustomersProjects.Status`,
        );

      return undefined;
    },
  },
  {
    dataType: IDataType.string,
    dataField: 'taskCustomId',
    width: '80px',
    caption: 'Task id',
    cssClass: 'dg-align-center',
  },
  {
    dataField: 'typeNameTranslated',
    width: '90px',
    caption: 'Type',
    lookupPickBy: 'typeNameTranslated',
    cssClass: 'dg-align-center',
    cellRender: TypeNameCell,
  },
  {
    dataField: 'workSheetStatusNameTranslated',
    caption: 'Status',
    width: '100px',
    cellRender: ChartCell,
    cssClass: 'dg-align-center',
  },
  {
    dataField: 'taskCreationTime',
    width: '120px',
    caption: 'Date of creation',
    dataType: IDataType.dateTime,
  },
  {
    dataField: 'activityDuration',
    width: '100px',
    caption: 'Activity Duration',
    cellRender: TimeSpanCell,
    calculateSortValue: function (rowData) {
      return TimeSpanCellSortValue(rowData, 'activityDuration');
    },
  },
  {
    dataField: 'activityDuration',
    width: '100px',
    caption: 'Activity Duration Hours',
    cellRender: TimeSpanDecimalCell,
    calculateSortValue: function (rowData) {
      return TimeSpanCellSortValue(rowData, 'activityDuration');
    },
  },  
  {
    dataField: 'activityStarted',
    width: '120px',
    caption: 'Activity Start',
    dataType: IDataType.dateTime,
  },
  {
    dataField: 'activityFinished',
    width: '120px',
    caption: 'Activity Finish',
    dataType: IDataType.dateTime,
  },
  {
    dataField: 'created',
    width: '120px',
    caption: 'Created',
    dataType: IDataType.dateTime,
  },
  {
    dataField: 'createdByName',
    width: '120px',
    caption: 'Created by',
    dataType: IDataType.dateTime,
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCellTaskWorkSheet(data, handleEdit, translate),
    width: '100px',
  },
];

const ButtonCellTaskWorkSheet = (cellData, handleEdit, translate) => {
  return (
    <DataGridButton
      hint={translate!('Edit', '')}
      icon="edit"
      cellData={cellData}
      onClick={handleEdit}
    />
  );
};
